import React from "react";
import { getWaypointIcon, MarkerType, markerTypeDisplayString } from "../risk/GeoMarkerUtils";
import { isPlannedWaypointType, wrapWaypointIcon } from "../risk/GeoMarkerTemplate";
import { getDefaultRvIcon } from "../risk/GeoRvSymbol";
import { routeRVIconScale } from "../../app/constants";
import { Stack, styled } from "@mui/material";
import { LegendProps } from "../risk/bottombar/Legend";
import { useIsRightBarExpanded } from "../../features/Drawer/drawerSlice";
import { useShouldShowAlerts } from "../../features/alertDisplay/alertDisplaySlice";
import { LegendContainer } from "../risk/bottombar/LegendStyle";

function getRow( background: JSX.Element | undefined, icon: JSX.Element, label: string )
{
    return (
        <Stack direction = "row" key = {"icon_row_" + label}>
            <div style = {{ width: "24px", height: "24px", marginRight: "7px", marginTop: "7px", marginLeft: "7px" }}>
                {background}
                {icon}
            </div>
            <span style = {{ padding: "3px", marginTop: "5px"/*, marginRight: "7px", marginTop: "7px", marginLeft: "7px"*/ }}>{label}</span>
        </Stack>
    );
}

const MapLegendContainer = styled( LegendContainer )<{ isMobile: boolean, isRightBarExpanded: boolean, isShowingAlerts: boolean }>( ( { isMobile, isRightBarExpanded } ) => ( {
    bottom: isMobile ? "270px" : "155px",
    flexDirection: "column",
    width: isMobile ? "220px" : "272px",
    height: "255px",
    right: isMobile ? "10px" : isRightBarExpanded ? "340px" : "16px",
    backgroundColor: "white"
} ) );

export default function MapIconLegend( { isMobile }: LegendProps )
{
    const icons: Array<JSX.Element> = [];
    const iconScale = routeRVIconScale;
    const types: Array<MarkerType> = [ MarkerType.PIT_STOP,
        MarkerType.BORDER_CROSSING,
        MarkerType.OVERNIGHT_STAY_RECOMMENDED,
        MarkerType.OVERNIGHT_STAY_REQUESTED,
        MarkerType.START,
        MarkerType.END,
        MarkerType.WEATHER_DELAY ];

    types.forEach( each =>
    {
        icons.push( getWaypointIcon( { type: each, scale: iconScale * 0.7, isRVIcon: false } ), );
    } );
    const isRightBarExpanded = useIsRightBarExpanded();
    const isShowingAlerts = useShouldShowAlerts();

    return (
        <MapLegendContainer id = "map-legend" isMobile = {isMobile} isRightBarExpanded = {isRightBarExpanded} isShowingAlerts = {isShowingAlerts}>

            {icons.map( ( each: JSX.Element, index: number ) =>
            {
                return getRow( wrapWaypointIcon( isPlannedWaypointType( types[index] ), iconScale ),
                    each,
                    markerTypeDisplayString( types[index] ) );
            } )}
            {getRow( undefined, getDefaultRvIcon( 25 ), "Your vehicle" )}

        </MapLegendContainer>
    );
}
